import * as React from 'react'
import moment from 'moment'
import { inject, observer } from 'mobx-react'
import { CurrentCompanyStore } from '../../../../../../stores/CurrentCompanyStore'
import { parseAndDownloadCSV } from '../../../../../../utilities/helpers'
import { ReportFilter } from '../../ReportFilter'
import { ReportFilterStore } from '../../ReportFilterStore'
import { CategoryTimeGraph } from './CategoryTimeGraph'
import { Skeleton } from 'antd'
import { CategorySummary } from './CategorySummary'
import Helmet from 'react-helmet'

interface Props {
  currentCompanyStore?: CurrentCompanyStore
  reportFilterStore?: ReportFilterStore
}

interface IOrder {
  field: string
  direction: 'asc' | 'desc'
}

type SortFields = 'categoryName' | 'total' | 'tax' | 'cost'

interface State {
  nested: boolean
  order: IOrder
  sort: { field: SortFields; direction: 'asc' | 'desc' }
}

@inject('currentCompanyStore', 'reportFilterStore')
@observer
export class CategoriesReport extends React.Component<Props, State> {
  // Static property that stores loaded report data
  data: any

  constructor(props: Props) {
    super(props)
    this.state = {
      nested: false,
      sort: {
        field: 'categoryName',
        direction: 'asc',
      },
      order: {
        field: 'Categories.fullname',
        direction: 'asc',
      },
    }
  }

  toggleSort(field: SortFields) {
    if (this.state.sort.field === field) {
      if (this.state.sort.direction === 'asc') {
        this.setState({
          sort: {
            field: field,
            direction: 'desc',
          },
        })
      } else {
        this.setState({
          sort: {
            field: field,
            direction: 'asc',
          },
        })
      }
    } else {
      this.setState({
        sort: {
          field: field,
          direction: 'desc',
        },
      })
    }
  }

  toggleOrder(fieldName: string) {
    if (this.state.order.field === fieldName) {
      const currentDirection = this.state.order.direction
      this.setState({
        order: {
          field: fieldName,
          direction: currentDirection === 'asc' ? 'desc' : 'asc',
        },
      })
    } else {
      this.setState({
        order: {
          field: fieldName,
          direction: 'desc',
        },
      })
    }
  }

  renderChart(Component: any) {
    return ({ resultSet, error }: any) => {
      if (resultSet) {
        this.data = resultSet.rawData()
      } else {
        this.data = undefined
      }
      return (
        (resultSet && <Component resultSet={resultSet} />) ||
        (error && error.toString()) || <Skeleton active />
      )
    }
  }

  exportCSV() {
    const { startDate, endDate } = this.props.reportFilterStore!
    const data = this.data
    if (data) {
      parseAndDownloadCSV(
        `category-report-${moment(startDate).format('YYYY-MM-DD')}-${moment(endDate).format(
          'YYYY-MM-DD',
        )}`,
        data,
      )
    }
  }

  render() {
    const { startDateString, endDateString, selectedLocationIds } = this.props.reportFilterStore!
    const currentCompanyStore = this.props.currentCompanyStore!
    const company = currentCompanyStore.company!

    return (
      <>
        <Helmet>
          <title>Reports | Category Sales</title>
          <meta name='page-loaded' content='true' />
        </Helmet>
        <ReportFilter />
        <div>
          <div className='rounded background-white'>
            <div className='p-3'>
              <CategoryTimeGraph
                companyId={company.id}
                startDate={startDateString}
                endDate={endDateString}
                locationIds={selectedLocationIds}
              />
            </div>
          </div>

          <br />

          <CategorySummary companyId={company.id} />
        </div>
      </>
    )
  }
}
